<template>
    <div class="card">
        <h1 class="card-header text-center">Health Plan</h1>
        <div class="card-body">
            <form ref="form" @submit.prevent="save">
                <div class="form-row">
                    <div class="col-sm-5 col-md-6">
                        <!-- <div class="alert" v-if="this.planData.hccisId === ''">This plan has already been claimed. If you
                            believe this is in error, please contact the system administrator.
                        </div> -->
                        <div class="form-group ">
                            <label for="hccisId">Health Plan ID:</label>
                            <input :disabled=true type="text" id="hccisId" required class="form-control"
                                   v-model.trim="$v.planData.hccisId.$model"
                                   :class="{'is-invalid': $v.planData.hccisId.$error}">
                            <span v-if="!$v.planData.hccisId.required" class="invalid-feedback">HCCIS Plan ID is required</span>
                        </div>
                    </div>
                    <div class="col-sm-4 col-sm-6">
                        <div class="form-group">
                            <p align="center">Calendar Year {{ planData.reportYear }}</p>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-sm-12 col-md-12">
                        <div> <!--col2 -->
                           <div class="form-group "><!--row1 -->
                               <label for="name"><strong>Company Name *:</strong></label>
                               <input type="text" id="name" required class="form-control" maxlength="100"
                                      v-model.trim="$v.planData.name.$model"
                                      :class="{'is-invalid': $v.planData.name.$error}">
                               <span v-if="!$v.planData.name.required"
                                     class="invalid-feedback">Company name is required</span>
                           </div>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-sm-5 col-md-6">
                        <div class="form-group"><!--row2 -->
                            <label for="naic">NAIC Code:</label>
                            <input type="text" id="naic" required class="form-control"
                                   v-model.trim="$v.planData.naic.$model"
                                   :class="{'is-invalid': $v.planData.naic.$error}">
                            <span v-if="!$v.planData.naic.invalid" class="invalid-feedback">NAIC is invalid</span>
                        </div>
                    </div>
                    <div class="col-sm-5 col-md-6">
                        <div class="form-group "><!--row2 -->
                            <label for="groupCode">Group Code:</label>
                            <input type="text" id="groupCode" required class="form-control"
                                   v-model.trim="$v.planData.groupCode.$model" maxlength="4"
                                   :class="{'is-invalid': $v.planData.groupCode.$error}">
                            <span v-if="!$v.planData.groupCode.invalid"
                                  class="invalid-feedback">Group Code is invalid</span>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="adminSalutation">Administrator/CEO Salutation:</label>
                            <div class="w-50">
                                <input type="text" id="adminSalutation" required class="form-control"
                                       v-model.trim="$v.planData.adminSalutation.$model" maxlength="25"
                                    :class="{'is-invalid': $v.planData.adminSalutation.$error}">
                            </div>
                            <span v-if="!$v.planData.adminSalutation.invalid" class="invalid-feedback">Administrator salutation is invalid</span>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="form-group">
                            <label for="adminnamef">Administrator/CEO First Name:</label>
                            <input type="text" id="adminnamef" required class="form-control"
                                   v-model.trim="$v.planData.adminnamef.$model" maxlength="50"
                                   :class="{'is-invalid': $v.planData.adminnamef.$error}">
                            <span v-if="!$v.planData.adminnamef.invalid"
                                  class="invalid-feedback">First name is invalid</span>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="form-group"><!--row3 -->
                            <label for="adminnamel">Administrator/CEO Last Name:</label>
                            <input type="text" id="adminnamel" required class="form-control"
                                   v-model.trim="$v.planData.adminnamel.$model" maxlength="50"
                                   :class="{'is-invalid': $v.planData.adminnamel.$error}">
                            <span v-if="!$v.planData.adminnamel.invalid"
                                  class="invalid-feedback">Last name is invalid</span>

                        </div>
                    </div>
                </div>
                <div class="form-row">
                     <div class="col-sm-12 col-md-12">
                        <div class="form-group"><!--row4 -->
                            <label for="admintitle">Administrator/CEO Title:</label>
                            <input type="text" id="admintitle" required class="form-control"
                                   v-model.trim="$v.planData.admintitle.$model" maxlength="25"
                                   :class="{'is-invalid': $v.planData.admintitle.$error}">
                            <span v-if="!$v.planData.admintitle.invalid"
                                  class="invalid-feedback">Title is invalid</span>
                        </div>
                     </div>
                </div>
                <div class="form-row">
                     <div class="col-sm-5 col-md-6">

                        <div class="form-group "><!--row6 -->
                            <label for="phone">Phone:</label>
                            <input type="tel" v-mask="'###-###-####'" id="phone" required class="form-control"
                                   v-model.trim="$v.planData.phone.$model"
                                   :class="{'is-invalid': $v.planData.phone.$error}">
                            <span v-if="!$v.planData.phone.invalid"
                                  class="invalid-feedback">Phone number is invalid</span>
                        </div>
                     </div>
                     <div class="col-sm-5 col-md-6">
                         <div class="form-group"><!--row6 -->
                             <label for="fax">Fax:</label>
                             <input type="tel" v-mask="'###-###-####'" id="fax" required class="form-control"
                                    v-model.trim="$v.planData.fax.$model"
                                    :class="{'is-invalid': $v.planData.fax.$error}">
                             <span> </span>
                         </div>
                     </div>
                </div>
                <div class="form-row">
                    <div class="col-sm-5 col-md-6">
                        <div class="form-group "><!--row5 -->
                            <label for="generalEmail">Email:</label>
                            <input type="email" id="generalEmail" required class="form-control"
                                   v-model.trim="$v.planData.generalEmail.$model"
                                   :class="{'is-invalid': $v.planData.generalEmail.$error}">
                            <span v-if="!$v.planData.generalEmail.invalid"
                                  class="invalid-feedback">Email is invalid</span>
                        </div>
                        <div class="form-group "><!--row5 -->
                            <label for="web">Website:</label>
                            <input type="url" id="web" required class="form-control"
                                   v-model.trim="$v.planData.web.$model"
                                   :class="{'is-invalid': $v.planData.web.$error}">
                            <span style=""> </span>
                        </div>
                    </div>

                </div>

                <div class="form-row">
                    <div class="col-sm-5 col-md-6">
                        <div class="form-group">
                            <label for="cfoName">CFO Name:</label>
                            <input type="text" id="cfoName" required class="form-control"
                                   v-model.trim="$v.planData.cfoName.$model" maxlength="100"
                                   :class="{'is-invalid': $v.planData.cfoName.$error}">
                            <span v-if="!$v.planData.cfoName.invalid"
                                  class="invalid-feedback">CFO name is invalid</span>
                        </div>
                    </div>
                </div>
                <p></p><strong>Mailing Address:</strong>
                <p></p>
                <div class="form-row">
                    <div class="col-sm-5 col-md-6">
                        <div class="form-group">
                            <label for="mailAddress">Address Line 1 *:</label>
                            <input type="text" id="mailAddress" required class="form-control"
                                   v-model.trim="$v.planData.mailAddress.$model"
                                   :class="{'is-invalid': $v.planData.mailAddress.$error}">
                            <span v-if="!$v.planData.mailAddress.invalid"
                                  class="invalid-feedback">Address is invalid</span>
                        </div>
                        <div class="form-group">
                            <label for="mailAddress2">Address Line 2:</label>
                            <input type="text" id="mailAddress2" required class="form-control"
                                   v-model.trim="$v.planData.mailAddress2.$model"
                                   :class="{'is-invalid': $v.planData.mailAddress2.$error}">
                            <span v-if="!$v.planData.mailAddress2.invalid" class="invalid-feedback">Address Line 2 is invalid</span>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-sm-5 col-md-6">
                        <div class="form-group">
                            <label for="mailCity"><strong>City *:</strong></label>
                            <input type="text" id="mailCity" required class="form-control"
                                   v-model.trim="$v.planData.mailCity.$model" v-uppercase
                                   v-on:change="saintToSt(1)"
                                   :class="{'is-invalid': $v.planData.mailCity.$error}">
                            <span v-if="!$v.planData.mailCity.invalid" class="invalid-feedback">City is invalid</span>
                        </div>
                    </div>
                    <div class="col-sm-5 col-md-6">
                        <div class="form-group">
                            <label for="mailCounty">County:</label>
                            <input type="text" id="mailCounty" required class="form-control"
                                   v-model.trim="$v.planData.mailCounty.$model" v-uppercase
                                   v-on:change="saintToSt(2)"
                                   :class="{'is-invalid': $v.planData.mailCounty.$error}">
                            <span v-if="!$v.planData.mailCounty.invalid"
                                  class="invalid-feedback">County is invalid</span>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-sm-5 col-md-6">

                        <div class="form-group">
                            <label for="mailState">State/Province: </label>
                            <v-select
                                    id="mailState"
                                    v-model.trim="$v.planData.mailState.$model"
                                    :options="stateProvince"
                                    :reduce="text => text.value"
                                    :items="stateProvince.value"
                                    label="text"
                                    type="select"
                                    placeholder="Select a state or province"
                                    :class="{'is-invalid': validationStatus($v.planData.mailState)}"
                            ></v-select>
                            <span v-if="!$v.planData.mailState.invalid"
                                  class="invalid-feedback">State is required</span>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-sm-5 col-md-6">
                        <div class="form-group" v-if="!selectedCountryCan($v.planData.mailState.$model)">
                            <label for="mailZip">U.S. ZIP Code or Canadian Postal Code:</label>
                            <input type="text" id="mailZip" v-mask="'#####'" class="form-control"
                                   v-model.trim="$v.planData.mailZip.$model"
                                   :class="{'is-invalid': $v.planData.mailZip.$error}"  >
                            <span v-if="!$v.planData.mailZip.invalid" class="invalid-feedback">Zip code is invalid</span>
                        </div>
                        <div class="form-group" v-if="selectedCountryCan($v.planData.mailState.$model)">
                            <label for="mailCanZip">U.S. ZIP Code or Canadian Postal Code:</label>
                            <input type="text" id="mailCanZip" v-mask="'A#A #A#'" class="form-control"
                                   v-model.trim="$v.planData.mailZipCan.$model"
                                   :class="{'is-invalid': $v.planData.mailZipCan.$error}" >
                            <span v-if="!$v.planData.mailZipCan.invalid"
                                  class="invalid-feedback">Postal code is invalid</span>
                        </div>
                    </div>
                    <div class="col-sm-5 col-md-6">
                        <div class="form-group" v-if="!selectedCountryCan($v.planData.mailState.$model)">
                            <label for="zipExt">U.S. ZIP Code Extension:</label>
                            <input :disabled="isDisabled(planData.mailZip.length)" type="text" id="zipExt" name="zipExt"
                                   v-mask="'####'" required class="form-control"
                                   v-model.trim="$v.planData.zipExt.$model"
                                   :class="{'is-invalid': $v.planData.zipExt.$error}">
                            <span v-if="!$v.planData.zipExt.invalid" class="invalid-feedback">Zip code extension is invalid</span>
                        </div>

                    </div>
                </div>
                <!-- <div class="form-row">
                        <div class="col-md-4"> <b-button variant="primary" to="search">Previous</b-button> </div>
                        <div class="col-md-4"> <b-button aria-colspan="2" variant="primary" v-on:click="submit" :disabled="this.planData.linkage.claimed == 1">Claim and continue</b-button> </div>
                </div> -->
                <!-- <div class="alert" v-if="this.planData.linkage.claimed">This plan has already been claimed. If you believe this is in error, please contact the system administrator.</div> -->
            </form>
        </div>
    </div>
</template>

<script>

    import {required, minLength, email, requiredIf} from 'vuelidate/lib/validators'
    import {validationMixin} from 'vuelidate';
    import lambdaURL from '../lambda'

    export default {

        directives: {
            uppercase: {
                update (el) {
                    el.value = el.value.toUpperCase()
                },
            }
        },

        mixins: [validationMixin],
        mounted() {
            this.id = this.$route.params.id;
            lambdaURL.getDemography(this.id, this.$keycloak.userName, this.$keycloak.fullName).then((res) => {
                Object.assign(this.$data.planData, res);
                this.planData.reportYearMonths = '12'
                this.$emit('mergeOriginal', this.$data);
                /**this.$data.planData = res;**/
            })
                .catch((err) => {
                })


        },
        data: function () {
            return {
                planData: {
                    hccisId: '',
                    naic: '',
                    adminSalutation: '',
                    adminnamef: '',
                    admintitle: '',
                    generalEmail: '',
                    phone: '',
                    name: '',
                    groupCode: '',
                    adminnamel: '',
                    web: '',
                    fax: '',
                    cfoName: '',
                    mailAddress: '',
                    mailCity: '',
                    mailCounty: '',
                    mailState: '',
                    mailZip: '',
                    mailZipCan: '',
                    zipExt: '',
                    linkage: {
                        claimed: null
                    },
                    reportYear: '',
                    reportYearMonths: '12'
                },
                stateProvince: [
                    {value: 'AL', text: 'AL – Alabama'},
                    {value: 'AK', text: 'AK – Alaska'},
                    {value: 'AS', text: 'AS – American Samoa'},
                    {value: 'AZ', text: 'AZ – Arizona'},
                    {value: 'AR', text: 'AR – Arkansas'},
                    {value: 'CA', text: 'CA – California'},
                    {value: 'CO', text: 'CO – Colorado'},
                    {value: 'CT', text: 'CT – Connecticut'},
                    {value: 'DE', text: 'DE – Delaware'},
                    {value: 'DC', text: 'DC – District of Columbia'},
                    {value: 'FM', text: 'FM – Federated States of Micronesia'},
                    {value: 'FL', text: 'FL – Florida'},
                    {value: 'GA', text: 'GA – Georgia'},
                    {value: 'GU', text: 'GU – Guam'},
                    {value: 'HI', text: 'HI – Hawaii'},
                    {value: 'ID', text: 'ID – Idaho'},
                    {value: 'IL', text: 'IL – Illinois'},
                    {value: 'IN', text: 'IN – Indiana'},
                    {value: 'IA', text: 'IA – Iowa'},
                    {value: 'KS', text: 'KS – Kansas'},
                    {value: 'KY', text: 'KY – Kentucky'},
                    {value: 'LA', text: 'LA – Louisiana'},
                    {value: 'ME', text: 'ME – Maine'},
                    {value: 'MH', text: 'MH – Marshall Islands'},
                    {value: 'MD', text: 'MD – Maryland'},
                    {value: 'MA', text: 'MA – Massachusetts'},
                    {value: 'MI', text: 'MI – Michigan'},
                    {value: 'MN', text: 'MN – Minnesota'},
                    {value: 'MS', text: 'MS – Mississippi'},
                    {value: 'MO', text: 'MO – Missouri'},
                    {value: 'MT', text: 'MT – Montana'},
                    {value: 'NE', text: 'NE – Nebraska'},
                    {value: 'NV', text: 'NV – Nevada'},
                    {value: 'NH', text: 'NH – New Hampshire'},
                    {value: 'NJ', text: 'NJ – New Jersey'},
                    {value: 'NM', text: 'NM – New Mexico'},
                    {value: 'NY', text: 'NY – New York'},
                    {value: 'NC', text: 'NC – North Carolina'},
                    {value: 'ND', text: 'ND – North Dakota'},
                    {value: 'MP', text: 'MP – Northern Mariana Islands'},
                    {value: 'OH', text: 'OH – Ohio'},
                    {value: 'OK', text: 'OK – Oklahoma'},
                    {value: 'OR', text: 'OR – Oregon'},
                    {value: 'PW', text: 'PW – Palau'},
                    {value: 'PA', text: 'PA – Pennsylvania'},
                    {value: 'PR', text: 'PR – Puerto Rico'},
                    {value: 'RI', text: 'RI – Rhode Island'},
                    {value: 'SC', text: 'SC – South Carolina'},
                    {value: 'SD', text: 'SD – South Dakota'},
                    {value: 'TN', text: 'TN – Tennessee'},
                    {value: 'TX', text: 'TX – Texas'},
                    {value: 'UT', text: 'UT – Utah'},
                    {value: 'VT', text: 'VT – Vermont'},
                    {value: 'VI', text: 'VI – Virgin Islands'},
                    {value: 'VA', text: 'VA – Virginia'},
                    {value: 'WA', text: 'WA – Washington'},
                    {value: 'WV', text: 'WV – West Virginia'},
                    {value: 'WI', text: 'WI – Wisconsin'},
                    {value: 'WY', text: 'WY – Wyoming'},
                    {value: 'AB', text: 'AB – Alberta'},
                    {value: 'BC', text: 'BC – British Columbia'},
                    {value: 'MB', text: 'MB – Manitoba'},
                    {value: 'NB', text: 'NB – New Brunswick'},
                    {value: 'NF', text: 'NF – Newfoundland'},
                    {value: 'NT', text: 'NT – Northwest Territories'},
                    {value: 'NS', text: 'NS – Nova Scotia'},
                    {value: 'NU', text: 'NU – Nunavut'},
                    {value: 'ON', text: 'ON – Ontario'},
                    {value: 'PE', text: 'PE – Prince Edward Island'},
                    {value: 'QC', text: 'QC – Quebec'},
                    {value: 'SK', text: 'SK – Saskatchewen'},
                    {value: 'YT', text: 'YT – Yukon'}
                ],
                hasError: false,
                contact: '',
                id: ''
            }
        },
        validations: {
            planData: {
                hccisId: {
                    required, minLength: minLength(1)
                },
                naic: {
                    required: false, minLength: minLength(1)
                },
                adminSalutation: {
                    required: false, minLength: minLength(1)
                },
                adminnamef: {
                    required: false, minLength: minLength(1)
                },
                admintitle: {
                    required: false, minLength: minLength(1)
                },
                generalEmail: {
                    required: false, email, minLength: minLength(1)
                },
                phone: {
                    required: false, minLength: minLength(1)
                },
                name: {
                    required
                },
                groupCode: {
                    required: false
                },
                adminnamel: {
                    required: false, minLength: minLength(1)
                },
                web: {
                    required: false, minLength: minLength(1)
                },
                fax: {
                    required: false
                },
                cfoName: {
                    required: false, minLength: minLength(1)
                },
                mailAddress: {
                    required, minLength: minLength(1)
                },
                mailAddress2: {
                    required: false, minLength: minLength(1)
                },
                mailCity: {
                    required, minLength: minLength(1)
                },
                mailCounty: {
                    required: false, minLength: minLength(1)
                },
                mailState: {
                    required: false
                },
                mailZip: {
                    required: false,
                    minLength: minLength(5)
                },
                mailZipCan: {
                    required: false,
                    minLength: minLength(7)
                },
                zipExt: {
                    required: false, minLength: minLength(4)
                },
                linkage: {
                    claimed: {
                        required: false
                    }
                }
            },
            form: ['planData'],
        },
        methods: {

            isRequired(value) {
                return value ? true : 'This field is required';
            },

            isDisabled: function (trueFalseFormula) {
                let disabledDefault = true;
                if (typeof trueFalseFormula === 'undefined' || trueFalseFormula === null) {
                    trueFalseFormula = 0;
                }
                if (trueFalseFormula !== 5) {
                    disabledDefault = true;
                    this.$data.planData.zipExt = '';
                } else if (trueFalseFormula == 5) {
                    disabledDefault = false;
                }
                return disabledDefault;

            },

            selectedCountryCan: function (stateOrProvince) {
                this.returnThisAnswer = false;
                if ( stateOrProvince=== 'AB' || stateOrProvince === 'BC' || stateOrProvince === 'MB'
                    || stateOrProvince === 'NB' || stateOrProvince === 'NF' || stateOrProvince === 'NS' || stateOrProvince === 'NU'
                    || stateOrProvince === 'NT' || stateOrProvince === 'ON' || stateOrProvince === 'PE' || stateOrProvince === 'QC'
                    || stateOrProvince === 'SK' || stateOrProvince === 'YU') {
                    this.returnThisAnswer = true;
                    this.$data.planData.mailZip = '';
                    this.$data.planData.zipExt = '';
                } else {
                    this.$data.planData.mailZipCan = '';
                }
                return this.returnThisAnswer;
            } ,

            validationStatus: function (validation) {
                return typeof validation != "undefined" ? validation.$error : false;
            } ,

            focusFirstStatus() {
                var errorElements = document.querySelectorAll(".is-invalid");
                if (errorElements && errorElements.length > 0) {
                    var elmnt = document.getElementById(errorElements[0].id);
                    elmnt.scrollIntoView();
                }
            } ,

            validate() {
                this.$v.form.$touch();
                var isValid = !this.$v.form.$invalid;
                //console.log('before: ' + isValid);
                this.$emit('on-validate', this.$data, isValid);
                this.$nextTick(() => this.focusFirstStatus());
                //console.log('after: ' + isValid);
                return isValid
            }
            ,
            checkZip5(value) {
                if (value.length != 5) {
                    this.$data.planData.zipExt = '';
                }
            },

            saintToSt(locationType) {
                if (locationType === 1) {
                    if (this.$data.planData.mailCity.substring(0,5).toUpperCase()=='SAINT') {
                        this.$data.planData.mailCity = this.$data.planData.mailCity.replace(/SAINT/i, 'ST.');
                    } else if (this.$data.planData.mailCity.substring(0,3).toUpperCase()=='ST ') {
                        this.$data.planData.mailCity = this.$data.planData.mailCity.replace(/ST/i, 'ST.');
                    }
                }
                if (locationType === 2) {
                    if (this.$data.planData.mailCounty.substring(0,5).toUpperCase()=='SAINT') {
                        this.$data.planData.mailCounty = this.$data.planData.mailCounty.replace(/SAINT/i, 'ST.');
                    } else if (this.$data.planData.mailCounty.substring(0,3).toUpperCase()=='ST ') {
                        this.$data.planData.mailCounty = this.$data.planData.mailCounty.replace(/ST/i, 'ST.');
                    }
                }    
             }

            /** submit() {
                    this.$v.$touch();
                    if (this.$v.$invalid) {
                        this.hasError = true;
                    } else {
                        this.hasError = false;
                        lambdaURL.proceedToContact(this.planData.hccisId, this.$keycloak.userName, this.$keycloak.userEmail).then((res) => {
                        this.contact = res;
                        })
                        .catch((err) => {
                        })
                        window.location.replace('/contact')
                    }
            } **/
        }
    }

</script>

<style>


</style>
